import { HttpMethod, Type } from "@/Utils/request/types";

export interface ShareSummary {
  lab: string;
  logo: string;
  patient_initials: string;
  expired: boolean;
  locked: boolean;
  expires_at: string;
}

export interface ShareUnlocked extends ShareSummary {
  token: string;
  patient: string;
  visit_date: string;
  tests: {
    title: string;
    ready: boolean;
    report: string | null;
    approved_at: string;
  }[];
  bill: { number: string } | null;
}

export interface ShareLink {
  code: string;
  url: string;
  expires_at: string;
}

/** Plan 32 F7: the patient's download link (public) and the staff side. */
export default {
  summary: {
    path: "/api/v1/clinova/r/{code}/",
    method: HttpMethod.GET,
    TRes: Type<ShareSummary>(),
    noAuth: true,
  },
  unlock: {
    path: "/api/v1/clinova/r/{code}/unlock/",
    method: HttpMethod.POST,
    TRes: Type<ShareUnlocked>(),
    TBody: Type<{ answer: string }>(),
    noAuth: true,
  },
  report: {
    path: "/api/v1/clinova/r/{code}/report/{reportId}/",
    method: HttpMethod.GET,
    TRes: Type<Blob>(),
    noAuth: true,
  },
  bill: {
    path: "/api/v1/clinova/r/{code}/bill/",
    method: HttpMethod.GET,
    TRes: Type<Blob>(),
    noAuth: true,
  },
  link: {
    path: "/api/v1/facility/{facilityId}/share_links/",
    method: HttpMethod.POST,
    TRes: Type<ShareLink>(),
    TBody: Type<{ encounter: string }>(),
  },
} as const;
